export default __webpack_public_path__ + "static/media/TranceFestival-FULL.06462519.mp3";